'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyId$() {
  this.c9n = null;
  this.c9o = false;
  this.c9l = null;
  this.c9m = false;
}
export { $c_Lpresto_types$PolicyId$ as $c_Lpresto_types$PolicyId$ };
$p = $c_Lpresto_types$PolicyId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyId$;
/** @constructor */
function $h_Lpresto_types$PolicyId$() {
}
export { $h_Lpresto_types$PolicyId$ as $h_Lpresto_types$PolicyId$ };
$h_Lpresto_types$PolicyId$.prototype = $p;
$p.cJd = (function() {
  if ((!this.c9o)) {
    this.c9n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c9o = true;
  }
  return this.c9n;
});
$p.H7 = (function() {
  if ((!this.c9m)) {
    this.c9l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c9m = true;
  }
  return this.c9l;
});
var $d_Lpresto_types$PolicyId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyId$, "presto.types$PolicyId$", ({
  a0X: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyId$ as $d_Lpresto_types$PolicyId$ };
var $n_Lpresto_types$PolicyId$;
function $m_Lpresto_types$PolicyId$() {
  if ((!$n_Lpresto_types$PolicyId$)) {
    $n_Lpresto_types$PolicyId$ = new $c_Lpresto_types$PolicyId$();
  }
  return $n_Lpresto_types$PolicyId$;
}
export { $m_Lpresto_types$PolicyId$ as $m_Lpresto_types$PolicyId$ };
//# sourceMappingURL=presto.types$-Policy-Id$.js.map
